module.exports = __webpack_public_path__ + "static/media/retro-board-dashboard.70ce411e.png";